import Grid from '../components/grid'
import SupportPlanTableHeader from '../components/support-plan-table-header'
import Container from '../components/ui/container'
import Divider from './Divider'
import { Page } from '@telesoft/types/payload-types'
import cn from 'classnames'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'support-plans-grid' }>

function SupportPlansGrid(block: BlockProps): ReactElement {
  const { packages } = block

  return (
    <>
      <Divider />
      <Container>
        <Grid className="">
          <SupportPlanTableHeader />
          {packages &&
            packages.map((pack: any) => {
              const arr = Object.entries(pack).filter((item: any) => item[0] !== 'id')
              return arr.map((item: any, i: number) => {
                const isShow = item[0] === 'one' || item[0] === 'two' || item[0] === 'three'
                let label
                switch (item[0]) {
                  case 'one':
                    label = 'Bronze'
                    break
                  case 'two':
                    label = 'Silver'
                    break
                  case 'three':
                    label = 'Gold'
                    break

                  default:
                    label = 'Packages'
                    break
                }
                return (
                  <>
                    {isShow && (
                      <div
                        className={cn(
                          `flex lg:hidden col-span-full lg:col-span-3 font-medium py-2 text-black uppercase font-terminal justify-start px-8 border-l border-t border-black`,
                        )}
                      >
                        {label}
                      </div>
                    )}
                    <div
                      key={`support--plan--map--${i}`}
                      className={cn(`col-span-full lg:col-span-3 flex text-black justify-start px-8 py-2`, {
                        'bg-telesoft border-l border-black justify-start text-opacity-80 font-terminal uppercase text-black font-medium':
                          item[0] === 'title',
                        'border-l border-black bg-accent-1 -mt-8 lg:mt-0': item[0] !== 'title',
                      })}
                    >
                      {item[1]}
                    </div>
                  </>
                )
              })
            })}
        </Grid>
      </Container>
      <Divider />
    </>
  )
}

export default SupportPlansGrid
